import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

import { AppStyleService } from 'src/app/services/app-style.service';
import { StoreService } from 'src/app/services/store.service';
import { UtilService } from 'src/app/services/util.service';
@Component({
	selector: 'app-dynamic-report',
	templateUrl: './dynamic-report.component.html',
	styleUrls: ['./dynamic-report.component.scss'],
})
export class DynamicReportComponent implements OnInit, OnDestroy, AfterViewInit {
	constructor(public _router: Router, public _util: UtilService, public _ss: StoreService, private _acr: ActivatedRoute, private _style: AppStyleService) {}

	loading = true;

	destroy$ = new Subject<void>();

	displayTotal$ = new BehaviorSubject<number>(0);
	displayAverage$ = new BehaviorSubject<number>(0);

	windowWidth = innerWidth;

	reportEndpoint: string | undefined = this._acr.snapshot.params['report'];

	headers = [];
	displayValues = [];

	reportName = 'דוח BI';

	@ViewChild('secondTable') secondTable: ElementRef<HTMLTableElement>;
	@ViewChild('header') header: ElementRef<HTMLHeadingElement>;

	async ngOnInit() {
		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		} else {
			this._router.navigate(['home']);
		}
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		// this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		// if (this._ss.CustomerInformation.HasMultipleCompanies !== '0') {
		// 	this.HasMultipleCompanys = Number(this._ss.CustomerInformation.HasMultipleCompanies) + 1;
		// }

		if (!this.reportEndpoint) {
			this._router.navigate(['home']);
		}
		this.handlePopulateName();
		this.handleGetInfo();
	}

	ngOnDestroy(): void {
		this._ss.openDohotThirdOnAgent = this._ss.openDohotFourthOnAgent = undefined;

		this.destroy$.next();
		this.destroy$.complete();
	}

	ngAfterViewInit(): void {
		let height = 0;
		const buttonRowHeight = 48;

		const zoomFactor = window.innerWidth > 768 ? 1.5 : 1;

		if (this.header.nativeElement) {
			height += this.header.nativeElement.getBoundingClientRect().height;
		}

		console.log({ height });

		this._style.updateCSSVariable({ variable: '--table-body-height', newValue: document.body.offsetHeight - height * zoomFactor * 2 + 'px' });
	}

	handleGetInfo() {
		if (!this.reportEndpoint) return;
		this._ss
			.getBIReport(this.reportEndpoint)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: res => {
					if (typeof res === 'string') {
						alert('ישנה תקלת בשרת, לא ניתן להביא נתונים');
						history.back();
						return;
					}

					this.headers = Object.keys(res.recordset[0]);

					console.log({ headers: this.headers });
					this.displayValues = res.recordset;
					this.loading = false;
				},
				error: () => {
					this.loading = false;
					alert('ישנה תקלת בשרת, לא ניתן להביא נתונים');
					history.back();
					return;
				},
			});
	}

	handlePopulateName() {
		console.log({ reports: this._ss.biUserAvailableReports, endpoint: this.reportEndpoint });
		const report = this._ss.biUserAvailableReports.find(report => report.ID === this.reportEndpoint.split('report')[this.reportEndpoint.split('report').length - 1]);

		if (report) {
			this.reportName = report.Name;
		}
	}

	goBack() {
		history.back();
	}
}
